import { axiosObject } from "../config";

function getSellerTeamMembers(user_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/team-members/_read`;
    let payload = {
      filterBy: [
        {
          attribute: "user_uuid",
          op: "eq",
          value: user_uuid,
        },
        {
          attribute: "user_uuid",
          op: "eq",
          value: user_uuid,
        },
      ],
      limitBy: {
        per_page: 1,
        page: 1,
      },
      apiConfig: {
        includeRelations: ["team"],
      },
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function verifyTeamMemberRequest(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/team-members/verify`;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export type AssetTransferAssetsReadOptions = {
  /** Values for `filterBy`: uuid `in` — use team `name` / `slug` from seller teams (same as stored on team row) */
  teamIdentifiers: string[];
  page?: number;
  perPage?: number;
};

/**
 * POST auction/data/resource/asset-transfer-assets/_read
 */
function getAssetTransferAssets(options: AssetTransferAssetsReadOptions) {
  const { teamIdentifiers, page = 1, perPage = 10 } = options;

  const filterBy =
    teamIdentifiers.length > 0
      ? [
          {
            attribute: "uuid",
            op: "in",
            value: teamIdentifiers
              .filter(Boolean)
              .filter((id, i, arr) => arr.indexOf(id) === i),
          },
        ]
      : [];

  const payload = {
    apiConfig: {
      includeRelations: "*",
      includeMutations: "*",
    },
    limitBy: {
      per_page: perPage,
      page,
    },
    sortBy: [],
    filterBy,
  };

  return new Promise((resolve, reject) => {
    axiosObject
      .post("auction/data/resource/asset-transfer-assets/_read", payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export type AssetTransferEventsReadOptions = {
  teamIdentifiers: string[];
  page?: number;
  perPage?: number;
};

function getAssetTransferEvents(options: AssetTransferEventsReadOptions) {
  const { teamIdentifiers, page = 1, perPage = 10 } = options;


  const payload = {
    apiConfig: {
      includeRelations: "*",
      includeMutations: "*",
    },
    limitBy: {
      per_page: perPage,
      page,
    },
    sortBy: [],
  };

  return new Promise((resolve, reject) => {
    axiosObject
      .post("auction/data/resource/asset-transfer-events/_read", payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAssetTransferEventByUuid(uuid: string) {
  const payload = {
    apiConfig: {
      includeRelations: "*",
      includeMutations: "*",
    },
    limitBy: {
      per_page: 1,
      page: 1,
    },
    sortBy: [],
    filterBy: [
      {
        attribute: "uuid",
        op: "eq",
        value: uuid,
      },
    ],
  };

  return new Promise((resolve, reject) => {
    axiosObject
      .post("auction/data/resource/asset-transfer-events/_read", payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export {
  getSellerTeamMembers,
  verifyTeamMemberRequest,
  getAssetTransferAssets,
  getAssetTransferEvents,
  getAssetTransferEventByUuid,
};
